import { Formik, type FormikProps, type FormikValues } from 'formik';
import React from 'react';
import * as Yup from 'yup';

type AppFormProps<T> = {
	children: React.ReactNode;
	initialValues: FormikValues & T;
	onSubmit: (values: FormikValues & T) => void;
	validationSchema?: Yup.InferType<Yup.AnyObjectSchema>;
	innerRef?: React.Ref<FormikProps<FormikValues & T>>;
};

function AppForm<T>({ initialValues, onSubmit, validationSchema, children, innerRef }: React.PropsWithChildren<AppFormProps<T>>) {
	return (
		<Formik innerRef={innerRef} enableReinitialize initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
			{() => <>{children}</>}
		</Formik>
	);
}

export default AppForm;
